import Repository from "./Repository";

/*
    API Access (static#49) — THE backend contract, in one place.

    Every /api-access call the frontend makes goes through this module, so a
    change to the contract is a change to this file only.

    GET    /api-access
        -> { status, apigwKeyValue, usagePlanId, callLimitEnabled,
             provisionedAt, rotatedAt, prevExpiresAt,
             usage: [{ date, used, remaining }],
             courseSelection: { wildcard, maxCourses } | null,
             courseChoice: { state, courses, pendingCourse, changedAt } | null }
           status is one of: none | pending | active | suspended | revoked | failed
           courseChoice (backend#125) is set only for a plan that chooses its
           courses (Single). state is "required" (the key reads NO course),
           "pending" (a downgrade: every course until the billing date, then
           pendingCourse, or nothing) or "chosen" (the key reads `courses`).

    POST   /api-access/provision   body { courseIds: number[] }
        -> { accessKeyId, secretAccessKey, apigwKeyValue }     ONE-TIME REVEAL
           400 { code: "INVALID_ARGUMENT" } when the courses break the plan's
           rules. The server re-derives the cap; the picker only explains it.

    POST   /api-access/rotate
        -> { accessKeyId, secretAccessKey, apigwKeyValue }     ONE-TIME REVEAL
           409 { code: "ROTATION_IN_PROGRESS", prevExpiresAt } when a 7-day
           dual-key grace window is still open.

    PUT    /api-access/call-limit   body { enabled: boolean }
        -> the updated GET shape

    PUT    /api-access/courses      body { courseIds: number[] }   (backend#125)
        -> the updated GET shape
           409 { code: "COURSE_CHANGE_LIMIT", nextChangeAt } when the course
           was already changed this billing period.

    GET    /api-access/usage        (static#9)
        -> { period: "DAY" | "WEEK" | "MONTH" | null,   null = no call limit
             limit: number | null, used: number,
             periodStart: ISO | null, resetsAt: ISO | null,
             thisMonth: { used: number },
             months: [{ month: "2026-08", used: number }],   newest first,
                                                     previous full months only
             historyStartsAt: "2026-03-03" | null }

    The user is identified from the bearer token injected by Repository.js —
    never from a path or body parameter.
*/

const apiAccess = "/api-access";
const provision = "/api-access/provision";
const rotate = "/api-access/rotate";
const callLimit = "/api-access/call-limit";
const courses = "/api-access/courses";
const usage = "/api-access/usage";

const ApiAccessRepository = {
  getApiAccess() {
    return Repository.get(`${apiAccess}`);
  },
  provisionApiAccess(courseIds) {
    return Repository.post(`${provision}`, { courseIds });
  },
  rotateApiAccess() {
    return Repository.post(`${rotate}`);
  },
  setCallLimit(enabled) {
    return Repository.put(`${callLimit}`, { enabled: !!enabled });
  },
  setCourses(courseIds) {
    return Repository.put(`${courses}`, { courseIds });
  },
  getUsage() {
    return Repository.get(`${usage}`);
  },
};

export default ApiAccessRepository;
